import { RESOURCE_NAME } from '@esentai/core/features/productCategories/consts';
import { canRead } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadProductsCategories = authorizeIf(canRead(RESOURCE_NAME));
